import React, {useEffect, useState} from "react";
import {apolloClientReports} from "../../../GraphQL/config";
import {QUERY_GET_WATER_CONSUMPTION_AND_ALERTS} from "../../../GraphQL/ReportGenerator/queries";
import {buildOverTimeCategoriesData, getEndDate, getResolutionName} from "../Utils/utils";
import {SITE_ENTITY_LABEL, VARIANT_SITES, WATER_SYSTEM_ENTITY_LABEL} from "../../../Constants/constants";
import {Spinner} from "react-bootstrap";
import WaterConsumptionAndAlertsCharts from "../WaterConsumptionAndAlertsCharts/WaterConsumptionAndAlertsCharts";
import convert, {DEFAULT_VOLUME_UNIT} from "../MeasurementText/MeasurementTextConverter";

export default function WaterConsumptionAndAlertsHighResolution(props) {
    const [chartData, setChartData] = useState();
    const [categories, setCategories] = useState();
    const [volumeUnit, setVolumeUnit] = useState(DEFAULT_VOLUME_UNIT);

    const getWaterConsumptionAndAlertsFromDB = async () => {
        await apolloClientReports.query({
            query: QUERY_GET_WATER_CONSUMPTION_AND_ALERTS, variables: {
                resolution: getResolutionName(props?.modalResulotion - 1),
                from: props?.selectedDate?.toISOString().split('T')[0],
                to: getEndDate(props?.selectedDate, props?.modalResulotion - 1).toISOString().split('T')[0],
                entityType: props.variant === VARIANT_SITES ? SITE_ENTITY_LABEL : WATER_SYSTEM_ENTITY_LABEL
            }
        }).then(res => {
            let response = res?.data?.waterConsumptionAndLeakAlertsHistogram;
            if (!response) {
                console.error(`Data from getLeakVolumeOverTimeFromDB is empty`);
            } else {
                setVolumeUnit(convert(response.measureUnit.volumeUnit));
                let selectedEntitiesIds = props?.selectedEntities?.map((entity) => entity.id);
                let usedEntities = response?.entities?.map((entity) => {
                    if (selectedEntitiesIds.includes(entity.id)) {
                        return entity
                    }
                }).filter((entity) => entity !== undefined);

                setChartData(usedEntities?.map((a, index) => {
                    return {
                        name: a.name,
                        consumptionData: a.data?.map((dat) => dat.waterConsumption),
                        leakAlerts: a.data?.map((dat) => dat.leakAlerts),
                        color: props?.colors[index]
                    }
                }));

                setCategories(buildOverTimeCategoriesData(usedEntities, props.modalResulotion - 1));
            }
        })
    }

    useEffect(() => {
        getWaterConsumptionAndAlertsFromDB();
    }, [props]);

    return (<>
        {!chartData && <Spinner animation="border" variant="primary"/>}
        {chartData && <WaterConsumptionAndAlertsCharts
            volumeUnit={volumeUnit}
            resolution={props.modalResulotion - 1}
            categories={categories}
            data={chartData}
        />}
    </>)
}